import { useState } from "react";
import {
  Button,
  Chip,
  Collapse,
  Dialog,
  DialogContent,
  Divider,
  Typography,
} from "../../../../../components";
import {
  history,
  NcmService,
  NfSaidaItensService,
  notification,
  ProdutosService,
} from "../../../../../services";
import { responseErros } from "../../../../../utils";

const nfSaidaItensService = new NfSaidaItensService();
const produtosService = new ProdutosService();
const ncmService = new NcmService();

const ErrosDfeDialog = ({
  open,
  setOpen,
  errosDfe,
  onClickEmitirNfSaidaEdicao,
  emitirNfSaida,
  onClickCriarContingenciaNfSaidaPendente,
  nfSaida,
  nfSaidaId,
  nfSaidaEntity,
  setNfSaidaProdutos,
  setLoadingAI,
  setMensagemLoadingAI,
  MENSAGEMLOADINGEMITIR,
}) => {
  const analiseAi = errosDfe?.analiseAi;
  const mensagem = errosDfe?.mensagem;

  const codigo = analiseAi?.rejeicao?.cStat;
  const resumo = analiseAi?.resumo;
  const correcoes = analiseAi?.correcoes || [];
  const xMotivo = analiseAi?.rejeicao?.xMotivo || "";
  const isRejeicao = /rejei/i.test(xMotivo);

  const correcoesNcm = analiseAi
    ? correcoes.filter((c) => /ncm/i.test(c.campo))
    : [];

  const [expandidoNcm, setExpandidoNcm] = useState(true);
  const [corrigindoNcm, setCorrigindoNcm] = useState(false);
  const [ncmCorrigido, setNcmCorrigido] = useState(false);

  const handleFechar = () => {
    if (nfSaida?.id) history.push(`/faturamento/nf-saida/${nfSaida.id}`);
    setOpen(false);
  };

  const handleCopiar = () => {
    if (mensagem) navigator.clipboard.writeText(mensagem);
  };

  async function buscarNcms(filtro) {
    const result = await ncmService.getAllAvancado({ ...filtro, limite: 20 });
    if (!result.isAxiosError) return result.data.rows;
    responseErros(result);
    return [];
  }

  async function aplicarCorrecoesNcm() {
    if (!nfSaidaEntity || !correcoesNcm.length) return;
    setCorrigindoNcm(true);
    try {
      const nfSaidaItens = nfSaidaEntity.nfSaidaItens || [];
      const itensAcorrigir = correcoesNcm
        .map((c) => {
          const base = nfSaidaItens[c.indiceItem];
          if (!base) return null;
          return {
            id: base.id,
            produtoId: base.produtoId,
            ncm: c.valorSugerido,
            ncmCodigo: c.valorSugerido,
            indiceItem: c.indiceItem,
          };
        })
        .filter(Boolean);
      if (!itensAcorrigir.length) return;
      const result = await nfSaidaItensService.atualizarLista(
        itensAcorrigir.map(({ id, ncm }) => ({ id, ncm })),
      );
      if (result.isAxiosError) return responseErros(result);

      nfSaidaEntity.nfSaidaItens = nfSaidaItens.map((item, idx) => {
        const atualizado = itensAcorrigir.find((i) => i.indiceItem === idx);
        return atualizado ? { ...item, ncm: atualizado.ncm } : item;
      });
      setNfSaidaProdutos((prev) =>
        prev.map((item, idx) => {
          const atualizado = itensAcorrigir.find((i) => i.indiceItem === idx);
          return atualizado ? { ...item, ncm: atualizado.ncm } : item;
        }),
      );

      await atualizarNcmProdutos(itensAcorrigir);
      notification.sucessoGenericos("Correções de NCM aplicadas com sucesso.");
      setNcmCorrigido(true);
    } catch (error) {
      notification.erroGenericos(
        "Erro ao aplicar correções de NCM. Verifique os dados e tente novamente.",
      );
    } finally {
      setCorrigindoNcm(false);
    }
  }

  async function atualizarNcmProdutos(itens) {
    const itensNcm = itens.filter((i) => i.ncmCodigo);
    if (!itensNcm.length) return;
    const codigos = [...new Set(itensNcm.map((i) => i.ncmCodigo))];
    const ncms = await buscarNcms({ codigo: codigos });
    if (!ncms?.length) return;
    const atualizados = itensNcm
      .map((item) => {
        const encontrado = ncms.find((n) => n.codigo === item.ncmCodigo);
        return encontrado ? { ...item, ncmId: encontrado.id } : item;
      })
      .filter(({ ncmId }) => typeof ncmId === "number");
    if (atualizados.length) await produtosService.atualizarLista(atualizados);
  }

  return (
    <Dialog disableEscapeKeyDown maxWidth="md" fullWidth open={open}>
      <form>
        <DialogContent style={{ padding: 0 }}>
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              padding: "24px 24px 16px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
              <div
                style={{
                  width: 48,
                  height: 48,
                  borderRadius: "50%",
                  backgroundColor: "#FEE2E2",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <i
                  className="ph-fill ph-warning"
                  style={{ fontSize: 24, color: "#DC3545" }}
                ></i>
              </div>
              <div>
                <Typography
                  variant="h6"
                  style={{ fontWeight: 600, lineHeight: 1.3 }}
                >
                  Falha ao emitir DF-E
                </Typography>
                <Typography variant="body2" style={{ color: "#6B7280" }}>
                  Retorno da SEFAZ
                </Typography>
              </div>
            </div>
            <button
              onClick={handleFechar}
              style={{
                background: "none",
                border: "none",
                cursor: "pointer",
                padding: 4,
                color: "#6B7280",
                fontSize: 22,
                lineHeight: 1,
              }}
            >
              <i className="ph ph-x"></i>
            </button>
          </div>

          {analiseAi && codigo && (
            <div style={{ display: "flex", gap: 8, padding: "0 24px 16px" }}>
              <span
                style={{
                  display: "inline-block",
                  padding: "3px 10px",
                  border: "1px solid #D1D5DB",
                  borderRadius: 4,
                  fontSize: 13,
                  fontWeight: 500,
                  color: "#374151",
                }}
              >
                Código {codigo}
              </span>
              {isRejeicao && (
                <span
                  style={{
                    display: "inline-block",
                    padding: "3px 10px",
                    backgroundColor: "#DC3545",
                    borderRadius: 4,
                    fontSize: 13,
                    fontWeight: 500,
                    color: "#fff",
                  }}
                >
                  Rejeição
                </span>
              )}
            </div>
          )}

          <Divider />

          <div style={{ padding: "16px 24px" }}>
            <Typography
              variant="caption"
              style={{
                fontWeight: 700,
                color: "#6B7280",
                letterSpacing: 1,
                display: "block",
                marginBottom: 8,
              }}
            >
              RETORNO DA SEFAZ
            </Typography>
            <div
              style={{
                backgroundColor: "#F9FAFB",
                border: "1px solid #E5E7EB",
                borderRadius: 6,
                padding: "12px 16px",
                marginBottom: analiseAi ? 16 : 0,
                fontFamily: "monospace",
                fontSize: 13,
                color: "#374151",
                lineHeight: 1.6,
                wordBreak: "break-word",
              }}
            >
              {mensagem}
            </div>

            {analiseAi && (
              <>
                {resumo && (
                  <>
                    <Typography
                      variant="caption"
                      style={{
                        fontWeight: 700,
                        color: "#6B7280",
                        letterSpacing: 1,
                        display: "block",
                        marginBottom: 8,
                      }}
                    >
                      O QUE ISSO SIGNIFICA
                    </Typography>
                    <div
                      style={{
                        backgroundColor: "#FEF2F2",
                        border: "1px solid #FECACA",
                        borderRadius: 6,
                        padding: "12px 16px",
                        marginBottom: correcoes.length ? 16 : 0,
                        fontSize: 14,
                        color: "#374151",
                      }}
                    >
                      {resumo}
                    </div>
                  </>
                )}

                {correcoes.length > 0 && (
                  <>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        marginBottom: 10,
                        marginTop: 4,
                      }}
                    >
                      <i
                        className="ph ph-lightbulb"
                        style={{ fontSize: 18, color: "#374151" }}
                      ></i>
                      <Typography
                        variant="body2"
                        style={{ fontWeight: 600, color: "#374151" }}
                      >
                        Como resolver
                      </Typography>
                    </div>
                    {correcoes.map((correcao, index) => (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          gap: 12,
                          marginBottom: 8,
                          alignItems: "flex-start",
                        }}
                      >
                        <span
                          className="rounded-2"
                          style={{
                            height: 22,
                            backgroundColor: "#374151",
                            color: "#fff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            paddingInline: 10,
                            fontSize: 12,
                            fontWeight: 600,
                            flexShrink: 0,
                          }}
                        >
                          Item {correcao.indiceItem + 1}
                        </span>
                        <Typography variant="body2" style={{ paddingTop: 2 }}>
                          {correcao.acao}
                        </Typography>
                      </div>
                    ))}
                  </>
                )}

                {correcoesNcm.length > 0 &&
                  nfSaidaEntity &&
                  setNfSaidaProdutos &&
                  !ncmCorrigido && (
                    <div style={{ marginTop: 16 }}>
                      <button
                        type="button"
                        onClick={() => setExpandidoNcm((v) => !v)}
                        style={{
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          background: "#FFF7ED",
                          border: "1.5px solid #FED7AA",
                          borderRadius: expandidoNcm ? "6px 6px 0 0" : 6,
                          padding: "10px 14px",
                          cursor: "pointer",
                          gap: 8,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                          }}
                        >
                          <i
                            className="ph-fill ph-tag"
                            style={{ fontSize: 16, color: "#C2410C" }}
                          ></i>
                          <Typography
                            variant="body2"
                            style={{ fontWeight: 600, color: "#C2410C" }}
                          >
                            {correcoesNcm.length} item(s) com NCM a corrigir
                            automaticamente
                          </Typography>
                          <Chip
                            label="NCM"
                            size="small"
                            style={{
                              backgroundColor: "#C2410C",
                              color: "#fff",
                              fontWeight: 700,
                              fontSize: 10,
                              height: 18,
                            }}
                          />
                        </div>
                        <i
                          className={`ph ph-caret-${
                            expandidoNcm ? "up" : "down"
                          }`}
                          style={{ fontSize: 16, color: "#C2410C" }}
                        ></i>
                      </button>

                      <Collapse inn={expandidoNcm}>
                        <div
                          style={{
                            border: "1.5px solid #FED7AA",
                            borderTop: "none",
                            borderRadius: "0 0 6px 6px",
                            backgroundColor: "#FFFBF5",
                            overflow: "hidden",
                          }}
                        >
                          {correcoesNcm.map((c, idx) => {
                            const item =
                              nfSaidaEntity?.nfSaidaItens?.[c.indiceItem];
                            return (
                              <div
                                key={idx}
                                className="d-flex align-items-center justify-content-between"
                                style={{
                                  flexWrap: "wrap",
                                  gap: 8,
                                  padding: "10px 14px",
                                  borderBottom:
                                    idx < correcoesNcm.length - 1
                                      ? "1px solid #FED7AA"
                                      : "none",
                                }}
                              >
                                <div className="d-flex align-items-center gap-2">
                                  <span
                                    className="rounded-2"
                                    style={{
                                      height: 20,
                                      backgroundColor: "#374151",
                                      color: "#fff",
                                      display: "inline-flex",
                                      alignItems: "center",
                                      paddingInline: 8,
                                      fontSize: 11,
                                      fontWeight: 600,
                                      flexShrink: 0,
                                    }}
                                  >
                                    Item {c.indiceItem + 1}
                                  </span>
                                  {item?.descricao && (
                                    <Typography
                                      variant="body2"
                                      style={{
                                        color: "#374151",
                                        fontWeight: 500,
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        maxWidth: 260,
                                      }}
                                    >
                                      {item.descricao}
                                    </Typography>
                                  )}
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8,
                                    flexWrap: "wrap",
                                  }}
                                >
                                  <Chip
                                    label={c.valorAtual || "—"}
                                    size="small"
                                    style={{
                                      backgroundColor: "#FEE2E2",
                                      color: "#991B1B",
                                      fontWeight: 700,
                                      fontSize: 12,
                                      border: "1px solid #FECACA",
                                    }}
                                  />
                                  <i
                                    className="ph ph-arrow-right"
                                    style={{ fontSize: 14, color: "#6B7280" }}
                                  ></i>
                                  <Chip
                                    label={c.valorSugerido}
                                    size="small"
                                    style={{
                                      backgroundColor: "#DCFCE7",
                                      color: "#166534",
                                      fontWeight: 700,
                                      fontSize: 12,
                                      border: "1px solid #BBF7D0",
                                    }}
                                  />
                                </div>
                              </div>
                            );
                          })}

                          <div
                            style={{
                              padding: "10px 14px",
                              borderTop: "1.5px solid #FED7AA",
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "center",
                            }}
                          >
                            <Typography
                              variant="body2"
                              gutterBottom
                              style={{
                                maxWidth: 400,
                                fontSize: 10.5,
                                color: "#6B7280",
                                marginRight: "auto",
                              }}
                            >
                              <i
                                className="ph-fill ph-warning"
                                style={{
                                  fontSize: 12,
                                  color: "#DC3545",
                                  marginRight: 4,
                                }}
                              ></i>
                              Atenção: As sugestões apresentadas são sugeridas
                              por Inteligência Artificial e podem conter
                              divergências. Recomendamos a validação com o
                              contador responsável e/ou consulta à tabela
                              oficial de NCM antes da utilização.
                            </Typography>
                            <Button
                              variant="contained"
                              color="success"
                              disableElevation
                              disabled={corrigindoNcm}
                              onClick={aplicarCorrecoesNcm}
                              style={{
                                paddingBlock: "2rem",
                                maxWidth: 200,
                                maxHeight: 40,
                              }}
                            >
                              {corrigindoNcm ? (
                                <span>Corrigindo...</span>
                              ) : (
                                <span>Corrigir NCMs automaticamente</span>
                              )}
                            </Button>
                          </div>
                        </div>
                      </Collapse>
                    </div>
                  )}
              </>
            )}
          </div>
          <Divider />
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "12px 24px",
              flexWrap: "wrap",
              gap: 8,
            }}
          >
            <Button variant="text" color="padrao" onClick={handleCopiar}>
              <i
                className="ph ph-copy"
                style={{ fontSize: 18, marginRight: 6 }}
              ></i>
              Copiar mensagem
            </Button>
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
              {nfSaida?.modeloDocumento === "65" && (
                <Button
                  variant="contained"
                  color="padrao"
                  onClick={() => {
                    setOpen(false);
                    onClickCriarContingenciaNfSaidaPendente();
                  }}
                >
                  Emitir em contingência
                </Button>
              )}
              {ncmCorrigido && (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={async () => {
                    setOpen(false);
                    if (nfSaidaId) {
                      await onClickEmitirNfSaidaEdicao();
                    } else if (nfSaida?.id) {
                      setMensagemLoadingAI(MENSAGEMLOADINGEMITIR);
                      await emitirNfSaida(nfSaida.id, setLoadingAI);
                    }
                  }}
                >
                  <i
                    className="ph ph-paper-plane-tilt"
                    style={{ color: "#FFFFFF", fontSize: 16, marginRight: 6 }}
                  ></i>
                  Tentar emitir novamente
                </Button>
              )}
            </div>
          </div>
        </DialogContent>
      </form>
    </Dialog>
  );
};

export default ErrosDfeDialog;
